import { Check, Hourglass, Zap } from 'lucide-react';

import { buildAnalyticsEventName, trackAnalyticsEvent } from '@/lib/analytics';
import { classNames } from '@/utils/classNames';

import styles from '@/styles/positions.module.css';

type ModeKey = 'quick' | 'complete';

type ModeCardProps = {
  mode: ModeKey;
  title: string;
  description: string;
  selected: boolean;
  onSelect: (mode: ModeKey) => void;
};

function getModeIcon(mode: ModeKey): JSX.Element {
  return mode === 'quick' ? <Zap size={18} /> : <Hourglass size={18} />;
}

export function ModeCard({ mode, title, description, selected, onSelect }: ModeCardProps): JSX.Element {
  return (
    <button
      type="button"
      className={styles.modeButton}
      onClick={() => {
        trackAnalyticsEvent(buildAnalyticsEventName(title, `match:start:mode:${mode}`));
        onSelect(mode);
      }}
      aria-pressed={selected}
    >
      <div className={classNames(styles.modeCard, selected && styles.modeCardActive)}>
        <div className={styles.modeCardTop}>
          <div>
            <p className={styles.modeCardTitle}>{title}</p>
            <p className={styles.modeCardMeta}>{description}</p>
          </div>
          <span className={styles.modeCardIcon} aria-hidden="true">
            {getModeIcon(mode)}
          </span>
        </div>

        {selected ? (
          <span className={styles.modeCardSelectedMark}>
            <Check size={14} />
            Selecionada
          </span>
        ) : null}
      </div>
    </button>
  );
}
